import ListingEnergyCertificateValue from './ListingEnergyCertificateValue';

export default ListingEnergyCertificateValue;
